import { Cake, Hash, User } from 'lucide-react';
import { Card, CardContent, Badge } from '@/components/ui';
import { formatarIdade, iniciais } from '@/lib/utils';
import type { ClinusPaciente } from '@/types/api';

interface Props {
  paciente: ClinusPaciente;
}

export function PacienteHeader({ paciente }: Props) {
  return (
    <Card data-testid="paciente-header">
      <CardContent className="p-4">
        <div className="flex items-center gap-4">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary text-lg font-semibold">
            {iniciais(paciente.ds_paciente)}
          </div>
          <div className="flex-1 min-w-0">
            <h2
              className="truncate text-lg font-semibold"
              title={paciente.ds_paciente}
            >
              {paciente.ds_paciente}
            </h2>
            <div className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-muted-foreground">
              <span className="inline-flex items-center gap-1">
                <Cake className="h-3.5 w-3.5" />
                {formatarIdade(paciente.dt_nascimento)} ({paciente.dt_nascimento})
              </span>
              <Badge variant="outline" className="capitalize">
                {paciente.ds_sexo === 'M'
                  ? 'Masculino'
                  : paciente.ds_sexo === 'F'
                    ? 'Feminino'
                    : 'Outro'}
              </Badge>
              {paciente.nr_cpf && (
                <span className="inline-flex items-center gap-1 text-xs">
                  <Hash className="h-3 w-3" />
                  CPF: {paciente.nr_cpf}
                </span>
              )}
            </div>
            {paciente.ds_mae && (
              <p className="mt-1 text-xs text-muted-foreground inline-flex items-center gap-1">
                <User className="h-3 w-3" /> Mãe: {paciente.ds_mae}
              </p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
